import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormControlName, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Observable, fromEvent, merge, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ServiceCategory } from 'src/app/db/models/categories';
import { ProService, Country } from 'src/app/db/models/pro-services';
import { ProfiledService } from 'src/app/db/models/profiled-service';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CategoryService } from 'src/app/services/category.service';
import { ProfiledServiceService } from 'src/app/services/profiled-service.service';
import { StatesCitiesService } from 'src/app/services/states-cities.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-managed-service-edit',
  templateUrl: './managed-service-edit.component.html',
  styleUrls: ['./managed-service-edit.component.scss']
})
export class ManagedServiceEditComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title_main = 'Business Information';
  title_sub = 'Profile Information';

  mform: FormGroup;

  m_service = new ProfiledService();
  p_service: ProService;
  private sub: Subscription;

  user:User;
  accept_creation: boolean;

  categories: ServiceCategory[];
  countries: Country[];
  states: string[];
  cities: string[];

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
        private router: Router,
        private service: ProfiledServiceService,
        private cservice: CategoryService,
        private sservice: StatesCitiesService,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private authenticate: AuthenticationService,
        private notify: ToastrService)
        {
          this.validationMessages = {
            name: {
              required: 'Service name is required'
          },
          description: {
            required: 'Please describe your service'
          },
          serviceCategoryId:  {
            required: 'Select at least one category'
          },
          contactNumber: {
            required: 'A working mobile contact is required'
          },
          country:{
            required: 'Please select your country of service'
          },
           state:{
            required: 'Please select your state of service'
          },
          city:{
            required: 'Please select your city of service'
          },
          //Profile Information
          firstname: {
            required: 'firstname is required'
          },
          lastname: {
            required: 'lastname is required'
          },
          contact: {
            required: 'A working mobile contact is required'
          },
          address: {
            required: 'A valid address is required'
          },
          email:{
            email: 'Please enter a valid email address'
          },
           username:{
            required: 'Please specify username'
          },
          passord:{
            required: 'Please enter a valid password'
          }

        }

        this.genericValidator = new GenericValidator(this.validationMessages);
        this.authenticate.currentUser.subscribe(x => this.user = x);

        }

  ngOnInit() {
    this.createDataForm();
    this.getCategories();

    // this.sub = this.route.paramMap.subscribe(
    //   params => {
    //     const id = params.get('id');
    //     this.getService(id);
    //   }
    // )

    const response_Url = this.router.url.toString();
    console.log(response_Url);
    this.validateCreateService(this.user, response_Url);

    this.countries = this.sservice.getCountries();
    this.country.valueChanges.subscribe((country) => {
      this.state.reset();
      this.state.disable();
      if (country) {
        this.states = this.sservice.getStatesByCountry(country);
        this.state.enable();
      }
    });

    this.state.valueChanges.subscribe((state) => {
      this.city.reset();
      this.city.disable();
      if (state) {
        this.cities = this.sservice.getCitiesByState(this.country.value, state);
        this.city.enable();
      }
    });

  }

  createDataForm(){
    this.mform = this.fb.group({
      name: [null, Validators.required],
      description: [null, Validators.required],
      serviceCategoryId: [null, Validators.required],
      contactNumber: [null, Validators.required],
      line: [null],
      country: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      //Profile Information

      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      contact: [null, Validators.required],
      address: [null, Validators.required],
      email: [null, Validators.email],
      username: [null, Validators.required],
      password: [null, Validators.required]
      // confirmPassword: [null, Validators.required]
    })
  }


  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.mform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.mform);
    });
  }

  getCategories(){
   // this.categories = this.cservice.categories;
    this.cservice.getAllServiceCategories().subscribe(
      data => {
        this.categories = data;
      }
    )
  }

  get name(){
    return this.mform.controls.name as FormControl;
  }

  get description(){
    return this.mform.controls.description as FormControl;
  }

  get serviceCategoryId(){
    return this.mform.controls.serviceCategoryId as FormControl;
  }

  get contactNumber(){
    return this.mform.controls.contactNumber as FormControl;
  }

  get line(){
    return this.mform.controls.line as FormControl;
  }

  get city() {
    return this.mform.controls.city as FormControl;
  }

  get state() {
    return this.mform.controls.state as FormControl;
  }

  get country() {
    return this.mform.controls.country as FormControl;
  }


  get firtsname(){
    return this.mform.controls.firstname as FormControl;
  }

  get lastname(){
    return this.mform.controls.lastname as FormControl;
  }

  get contact(){
    return this.mform.controls.contact as FormControl;
  }

  get address(){
    return this.mform.controls.address as FormControl;
  }

  get email(){
    return this.mform.controls.email as FormControl;
  }

  get username() {
    return this.mform.controls.username as FormControl;
  }

  get password() {
    return this.mform.controls.password as FormControl;
  }

  mapEntity(): void {
    this.m_service.name = this.name.value;
    this.m_service.description = this.description.value;
    this.m_service.serviceCategoryId = this.serviceCategoryId.value;
    this.m_service.primaryContactNumber = this.contactNumber.value;
    this.m_service.addressLine  = this.line.value;
    this.m_service.city = this.city.value;
    this.m_service.state = this.state.value,
    this.m_service.country = this.country.value;
    //Profile Information
    this.m_service.firstname = this.firtsname.value;
    this.m_service.lastname = this.lastname.value;
    this.m_service.contact = this.contact.value;
    this.m_service.address = this.address.value;
    this.m_service.email  = this.email.value;
    this.m_service.username = this.username.value;
    this.m_service.password = this.password.value;
  }

  saveData(){
    this.spinner.show();
    if(this.mform.valid){
      this.mapEntity();
      console.log('New Service', this.m_service);
      if (this.m_service.id == null) {
        this.service.createManagedService(this.m_service)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.successNotification();
          },
          error: err => {
            this.spinner.hide();
            this.errorNotification();

          }
        })
      }
    }
  }

  successNotification(){
    Swal.fire({
      icon: 'success',
      title: 'Awesome',
      text:'Your are good to go!',
      showDenyButton: false,
      focusConfirm: true,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok',
    }).then((result) => {
      if(result.isConfirmed){
        this.redirect();
      }
    })
  }

  errorNotification(){
    Swal.fire({
      icon: 'error',
      title: 'Oops',
      text: 'Service with the same name already exist!',
      showDenyButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-repeat"></i> Try Again!',
      denyButtonText: `<i class="fa fa-power-off"></i> Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.reload();
      } else {
        this.abort();
      }
    })
  }

  abort(){
     this.router.navigate(['/']);
    }

  redirect(){
    this.router.navigate(['login']);
  }


  reload(){
     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
       this.router.navigate(['create_profiled_service']);
     })
    }

    validateCreateService(user:User, url_route){
      const myroute =  '/create_profiled_service';
      if(user !== null && url_route === myroute){
        // console.log(user, url_route,"accept creation failed")
        this.accept_creation = false;
      }
      if(user === null && url_route === myroute){
        this.accept_creation = true;
        console.log("accept creation passed")
      }
    }

    confirmSignOut(){
      this.authenticate.logout();
      this.router.navigate(['/']);
      this.notify.success('Logged Out Succesfully');
    }

}
